// extracted by mini-css-extract-plugin
export default {"tooltip":"CygnusTooltip_tooltip__jWaEA"};